var SkapaDurationEnum;
(function (SkapaDurationEnum) {
    SkapaDurationEnum["instant"] = "0ms";
    SkapaDurationEnum["quick"] = "100ms";
    SkapaDurationEnum["standard"] = "200ms";
    SkapaDurationEnum["slow"] = "250ms";
})(SkapaDurationEnum || (SkapaDurationEnum = {}));
export default SkapaDurationEnum;
//# sourceMappingURL=SkapaDurationEnum.js.map